import { useFormikContext } from "formik";
import { FC } from "react";
import { useLocale } from "@/contexts/localeContext";
import { TranslationKeys } from "@/contexts/TranslationKeys";
import { convertDateToString } from "@/services/utilities/dateFormatting";
import { WizardSummaryLayout } from '@/components/wizard/wizard-summary-layout';

interface SummaryStepProps {
    assigningType: "MEMBERS"| "EXPIRY_REASONS"
    idPath: string;
    originalSelectedRows: any[];
    onBack: (event: any) => void;
}

const SummaryStep: FC<SummaryStepProps> = ({ onBack, originalSelectedRows, idPath, assigningType }) => {
    const { values } = useFormikContext<any>();
    const { translate } = useLocale();
    const selectedRows = values.selectedRows || [];
    const toBeUnassignedRows = originalSelectedRows.filter((row: any) => !selectedRows.some((current: any) => current.id.toString() === row[idPath]));
    const toBeAssignedRows = selectedRows.filter((row: any) => !originalSelectedRows.some((original: any) => original[idPath] === row.id.toString()));

    return <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)}>
        <div className="flex flex-row">
            <div className="flex flex-col flex-1">
                <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.summary)}:</h2>
                {/* To be assigned */}
                <div className="flex flex-row flex-1 pb-2">
                    <span className="p-1 text-xs text-gray-600 w-1/2">{translate.byKey(TranslationKeys.toBeAssigned)}</span>
                        <div className="flex flex-col w-full">
                            {toBeAssignedRows.length > 0 ? 
                            <div className="grid grid-cols-2 gap-2">
                                <div className="flex flex-col">
                                    <span className="text-sm font-semibold text-black">{translate.byKey(TranslationKeys.name)}</span>
                                    {toBeAssignedRows.map(reason => {
                                        return <span className="text-xs">{reason.name}</span>
                                    })}
                                </div>
                                <div className="flex flex-col">
                                    <span className="text-sm font-semibold text-black">{translate.byKey(TranslationKeys.date)}</span>
                                    {toBeAssignedRows.map(reason => {
                                        return <span className="text-xs">{values.useSameDate || assigningType === "MEMBERS" ? convertDateToString(values.startDate) : convertDateToString(values[`startDate_${reason.id}`])}</span>
                                    })}
                                </div>
                            </div> : <span className="text-sm">{translate.byKey(TranslationKeys.none)}</span> }
                        </div>
                </div>
                <hr/>
                {/* To be unassigned */}
                <div className="flex flex-row flex-1 space-y-1">
                    <span className="p-1 text-xs text-gray-600 w-1/2">{translate.byKey(TranslationKeys.toBeUnassigned)}</span>
                    <div className="flex flex-col w-full">
                        {toBeUnassignedRows.length > 0 ? toBeUnassignedRows.map(reason => {
                            return <span className="text-xs">{reason.name}</span>
                        }): <span className="text-xs">{translate.byKey(TranslationKeys.none)}</span> } 
                    </div> 
                </div>
            </div>
        </div>
    </WizardSummaryLayout>
};

export default SummaryStep;